var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Events" } },
        [
          _c("h4", [
            _vm._v("Significant events generated during the simulation run"),
          ]),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Stock-outs and expiration tracker" } },
            [
              _c("EventsMap", { attrs: { "chart-name": "eventsMap" } }),
              _vm._v(" "),
              _c("DownloadLog"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }